
import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import BusinessSearchField from '@/components/business/businessSearch/BusinessSearchField';
import { MockGooglePlace } from '@/utils/mockGoogleMapsApi';
import { useBusinessFormContext } from '@/context/BusinessFormContext';
// import { useSectionNavigation } from './hooks/useSectionNavigation'; // To be replaced by prop
import PromoVideo from './PromoVideo';
import { Separator } from '@/components/ui/separator';

interface SearchSectionProps {
  onBusinessSelect: (business: MockGooglePlace) => void; // This will be useBusinessSelection.handleBusinessSelect
  onCreateNew: (businessName: string) => void;      // This will be useBusinessSelection.handleCreateNew
  onBackButtonClick?: () => void;
}

const SearchSection: React.FC<SearchSectionProps> = ({
  onBusinessSelect,
  onCreateNew,
  onBackButtonClick // This prop is for navigating away from the entire FirstBusinessForm flow
}) => {
  const isMobile = useIsMobile();
  // setSelectedBusiness is still needed here if onBusinessSelect doesn't handle it.
  // Let's assume onBusinessSelect (which is useBusinessSelection.handleBusinessSelect)
  // should be responsible for all state updates including selectedBusiness.
  // For now, keep setSelectedBusiness from context if needed.
  const { setSelectedBusiness } = useBusinessFormContext(); 
  // const { handleCreateNew: handleCreateNewFromNav } = useSectionNavigation(); // No longer using this directly

  const handleCreateNewWrapper = (businessName: string) => {
    console.log("SearchSection: handleCreateNewWrapper called with name:", businessName);
    if (businessName && businessName.trim()) {
      onCreateNew(businessName); // Call the prop
    }
  };

  const localHandleBusinessSelect = (business: MockGooglePlace) => {
    console.log("SearchSection: localHandleBusinessSelect called for:", business.name);
    // The prop onBusinessSelect (which is useBusinessSelection.handleBusinessSelect)
    // is expected to handle setting businessDetails, formSection, etc.
    // It might also handle setSelectedBusiness. If not, set it here.
    setSelectedBusiness(business); // Set the selected business in context
    onBusinessSelect(business); // Call the prop, which triggers detailed fetching and state updates
  };

  return (
    <div className="space-y-6 pt-4 md:pt-0">
      <div className="mb-8">
        <h2 className="text-lg font-medium mb-2 px-2.5 md:px-0">Find your business</h2>
        <p className="text-sm text-gray-500 mb-4 px-2.5 md:px-0">
          Search for your business to fill in details automatically or create a new one.
        </p>
        <BusinessSearchField
          onBusinessSelect={localHandleBusinessSelect} // Use the wrapper
          onCreateNew={handleCreateNewWrapper}
          className="z-[100]"
        />
      </div>
      
      {/* Added margin-top (mt-16) before separator and margin-bottom (mb-16) after separator */}
      <div className="mt-16 mb-16 px-2.5 md:px-0">
        <Separator />
      </div>
      
      {/* Added margin-top (mt-16) to the PromoVideo component */}
      <div className="mt-16">
        <PromoVideo />
      </div>
    </div>
  );
};

export default SearchSection;
